import React from 'react';

import { faChevronLeft, faFaceUnamused } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage, useIntl } from 'react-intl';
import { Link, useParams } from 'react-router-dom';

import { useGetMembershipGroup } from 'src/features/memberships/api/useGetMembershipGroup';
import { MembershipGroupDashboard } from 'src/features/memberships/components/MembershipGroupDashboard';
import { membershipMessages } from 'src/features/memberships/utils/messages';
import { MembershipVehicleLayoutContextProvider } from 'src/providers/MembershipVehiclesLayoutProvider';
import { useParking } from 'src/providers/ParkingProvider';
import GeneralMessageBlock from 'src/registry/components/blocks/GeneralMessageBlock';
import { Button } from 'src/registry/ui/Button';
import { useTitleStore } from 'src/stores/useTitleStore';

const MembershipGroup = () => {
    const { formatMessage } = useIntl();
    const { parkingId } = useParking();
    const { membershipGroupId } = useParams();
    const { setTitle, removeTitle } = useTitleStore();

    const {
        data: membershipGroup,
        isError: isErrorMembershipGroup,
        isLoading: isLoadingMembershipGroup,
        refetch: refetchMembershipGroup,
    } = useGetMembershipGroup({
        parkingId: parkingId || '',
        membershipGroupId: parseInt(membershipGroupId || '', 10),
        config: { enabled: !!membershipGroupId && !!parkingId },
    });

    React.useEffect(() => {
        if (!membershipGroup) return;
        setTitle(membershipGroup.name);
        return () => {
            removeTitle();
        };
    }, [membershipGroup]);

    if (isErrorMembershipGroup) {
        return (
            <>
                <Button asChild className="-mt-6 place-self-start p-0" variant="link">
                    <Link to="/vehicles/memberships">
                        <FontAwesomeIcon icon={faChevronLeft} className="opacity-50" />
                        <FormattedMessage {...membershipMessages.backToAllMemberships} />
                    </Link>
                </Button>
            </>
        );
    }

    return (
        <>
            <Button asChild className="-mt-6 place-self-start p-0" variant="link">
                <Link to="/vehicles/memberships">
                    <FontAwesomeIcon icon={faChevronLeft} className="opacity-50" />
                    <FormattedMessage {...membershipMessages.backToAllMemberships} />
                </Link>
            </Button>
            {isErrorMembershipGroup ? (
                <div className="pointer-events-none flex size-full flex-1 flex-col items-center justify-center pb-40">
                    <GeneralMessageBlock
                        className="py-12"
                        variant="error"
                        icon={faFaceUnamused}
                        title={formatMessage(membershipMessages.membershipGroupNotFound)}
                        subtitle={formatMessage(membershipMessages.membershipGroupNotFoundDescription)}
                    />
                </div>
            ) : (
                <MembershipVehicleLayoutContextProvider>
                    <MembershipGroupDashboard
                        membershipGroup={membershipGroup}
                        isLoadingMembershipGroup={isLoadingMembershipGroup}
                        refetchMembershipGroup={refetchMembershipGroup}
                    />
                </MembershipVehicleLayoutContextProvider>
            )}
        </>
    );
};
export { MembershipGroup };
